export const paremetersForRedirectUrl = {

    en: {
        hunters: {
            backgroundUrl: '/assets/img/BG/bg-trainerhub_hunters.jpg',
            welcomeLogoCenter: '/assets/img/Home/welcome_hunters.png',
            title: '',
            welcomeLogoBottom: '',
            kmonLogoPath: './assets/img/Icon/kmon-new-black_hunters.png',
            welcomeBackLabel: 'Welcome Hunter',
            startFree: 'Start your collection',
            createAccount: "Enter the Hunter Hub",
            subTitle: "Create and manage your digital <strong>KMON Card Deck</strong>."
        },
        wok: {
            title: '',
            backgroundUrl: '/assets/img/BG/BG-Kogaea-Dungeon.png',
            welcomeLogoBottom: '/assets/img/Home/Kogaea-Dungeons.png',
        },
        sale: {
            title: '',
            backgroundUrl: '/assets/img/BG/WoK-Hero-BG.png',
            welcomeLogoBottom: '/assets/img/Home/BabyDoge Head Trainer wok group.png',
        },
        wok_signup_success: {
            hideBackButton: true
        }

    },
    it: {
        hunters: {
            backgroundUrl: '/assets/img/BG/bg-trainerhub_hunters.jpg',
            title: '',
            welcomeLogoBottom: '',
            welcomeLogoCenter: '/assets/img/Home/welcome_hunters.png',
            kmonLogoPath: './assets/img/Icon/kmon-new-black_hunters.png',
            welcomeBackLabel: 'Bentornato Hunter',
            startFree: 'Inizia la tua collezione',
            createAccount: "Entra nell'Hunter Hub",
            subTitle: "Crea e gestisci il tuo <strong>KMON Card Deck<strong/>"
        },
        wok: {
            title: '',
            backgroundUrl: '/assets/img/BG/BG-Kogaea-Dungeon.png',
            welcomeLogoBottom: '/assets/img/Home/Kogaea-Dungeons.png',
        },
        sale: {
            title: '',
            backgroundUrl: '/assets/img/BG/WoK-Hero-BG.png',
            welcomeLogoBottom: '/assets/img/Home/BabyDoge Head Trainer wok group.png',
        },
        wok_signup_success: {
            hideBackButton: true
        }

    },
    es: {
        wok: {
            title: '',
            backgroundUrl: '/assets/img/BG/BG-Kogaea-Dungeon.png',
            welcomeLogoBottom: '/assets/img/Home/Kogaea-Dungeons.png',
        },
        sale: {
            title: '',
            backgroundUrl: '/assets/img/BG/WoK-Hero-BG.png',
            welcomeLogoBottom: '/assets/img/Home/BabyDoge Head Trainer wok group.png',
        },
        wok_signup_success: {
            hideBackButton: true
        }

    },
    pt: {
        wok: {
            title: '',
            backgroundUrl: '/assets/img/BG/BG-Kogaea-Dungeon.png',
            welcomeLogoBottom: '/assets/img/Home/Kogaea-Dungeons.png',
        },
        sale: {
            title: '',
            backgroundUrl: '/assets/img/BG/WoK-Hero-BG.png',
            welcomeLogoBottom: '/assets/img/Home/BabyDoge Head Trainer wok group.png',
        },
        wok_signup_success: {
            hideBackButton: true
        }

    },
    jp: {
        wok: {
            title: '',
            backgroundUrl: '/assets/img/BG/BG-Kogaea-Dungeon.png',
            welcomeLogoBottom: '/assets/img/Home/Kogaea-Dungeons.png',
        },
        sale: {
            title: '',
            backgroundUrl: '/assets/img/BG/WoK-Hero-BG.png',
            welcomeLogoBottom: '/assets/img/Home/BabyDoge Head Trainer wok group.png',
        },
        wok_signup_success: {
            hideBackButton: true
        }

    },
    default: {
        backgroundUrl: '/assets/img/BG/WoK-Hero-BG.png',
        title: '',
        // title: 'default',
        welcomeLogoCenter: '',
        // welcomeLogoBottom: './assets/img/Home/genesis.png',
        welcomeLogoBottom: '',
        kmonLogoPath: './assets/img/Icon/kmon-new-black.png',
    }
}